"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureToolbarButtons = exports.buttonList = exports.CommentButton = exports.InlineButton = exports.ListButton = exports.BlockButton = exports.StyleButton = exports.MenuButton = exports.ToolbarButton = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var Utils_1 = require("../Utils");
var Models_1 = require("ContentTokens/Models");
var EditorMarks_1 = require("../Marks/EditorMarks");
var ToolbarButton = (function () {
    function ToolbarButton() {
    }
    return ToolbarButton;
}());
exports.ToolbarButton = ToolbarButton;
var MenuButton = (function (_super) {
    __extends(MenuButton, _super);
    function MenuButton(type, icon) {
        var _this = _super.call(this) || this;
        _this.action = function (visualState) {
            return {
                contextualStylesShowing: !visualState.contextualStylesShowing,
            };
        };
        _this.type = type;
        _this.slateButton = false;
        _this.content = icon;
        return _this;
    }
    MenuButton.prototype.isActive = function (editor, visualState) {
        return visualState.contextualStylesShowing;
    };
    return MenuButton;
}(ToolbarButton));
exports.MenuButton = MenuButton;
var StyleButton = (function (_super) {
    __extends(StyleButton, _super);
    function StyleButton(type, icon) {
        var _this = _super.call(this) || this;
        _this.type = type;
        _this.content = icon;
        _this.slateButton = true;
        return _this;
    }
    StyleButton.prototype.isActive = function (editor) {
        var _this = this;
        var activeMarks = (0, EditorMarks_1.getCurrentMarks)(editor);
        return activeMarks.some(function (m) { return m.type === _this.type; });
    };
    return StyleButton;
}(ToolbarButton));
exports.StyleButton = StyleButton;
var BlockButton = (function (_super) {
    __extends(BlockButton, _super);
    function BlockButton(type, icon, data) {
        var _this = _super.call(this) || this;
        _this.type = type;
        _this.content = icon;
        _this.slateButton = true;
        if (data) {
            _this.data = data;
        }
        return _this;
    }
    BlockButton.prototype.isActive = function (editor) {
        var _this = this;
        var selectedBlocks = (0, Utils_1.getSelectedBlocks)(editor);
        return selectedBlocks.some(function (entry) { return entry[0].type == _this.type; });
    };
    return BlockButton;
}(ToolbarButton));
exports.BlockButton = BlockButton;
var ListButton = (function (_super) {
    __extends(ListButton, _super);
    function ListButton(listType, icon) {
        var _this = _super.call(this, "listItem", icon, { listType: listType }) || this;
        _this.slateButton = true;
        return _this;
    }
    ListButton.prototype.isActive = function (editor) {
        var _this = this;
        var selectedBlocks = (0, Utils_1.getSelectedBlocks)(editor);
        return selectedBlocks.some(function (entry) {
            var node = entry[0];
            return node.type == "listItem" && node.type == _this.type && node.data.listType == _this.data.listType;
        });
    };
    return ListButton;
}(BlockButton));
exports.ListButton = ListButton;
var InlineButton = (function (_super) {
    __extends(InlineButton, _super);
    function InlineButton(type, icon) {
        var _this = _super.call(this) || this;
        _this.type = type;
        _this.content = icon;
        _this.slateButton = true;
        return _this;
    }
    InlineButton.prototype.isActive = function (editor) {
        var _this = this;
        var selectedBlocks = (0, Utils_1.getSelectedBlocks)(editor);
        return selectedBlocks.some(function (entry) { return entry[0].type == _this.type; });
    };
    return InlineButton;
}(ToolbarButton));
exports.InlineButton = InlineButton;
var CommentButton = (function () {
    function CommentButton() {
        this.type = EditorTypes_1.MarkType.Comment;
        this.slateButton = true;
        this.data = {};
        this.content = (react_1.default.createElement("div", null,
            react_1.default.createElement(icons_1.AddComment, null)));
    }
    CommentButton.prototype.isActive = function (editor) {
        return false;
    };
    return CommentButton;
}());
exports.CommentButton = CommentButton;
exports.buttonList = {
    bold: function () {
        return new StyleButton(EditorTypes_1.MarkType.Bold, react_1.default.createElement(icons_1.Bold, null));
    },
    italic: function () {
        return new StyleButton(EditorTypes_1.MarkType.Italic, react_1.default.createElement(icons_1.Italic, null));
    },
    strikethrough: function () {
        return new StyleButton(EditorTypes_1.MarkType.Strikethrough, react_1.default.createElement(icons_1.Strikethrough, null));
    },
    heading1: function () {
        return new BlockButton("heading1", react_1.default.createElement(icons_1.H1, null));
    },
    heading2: function () {
        return new BlockButton("heading2", react_1.default.createElement(icons_1.H2, null));
    },
    link: function () {
        return new InlineButton(Models_1.InlineType.Link, react_1.default.createElement(icons_1.Link, null));
    },
    blockQuote: function () {
        return new BlockButton("blockQuote", react_1.default.createElement(icons_1.PullQuote, null));
    },
    bulletList: function () {
        return new ListButton("bullet", react_1.default.createElement(icons_1.ListBullet, null));
    },
    numberList: function () {
        return new ListButton("number", react_1.default.createElement(icons_1.ListNumber, null));
    },
    style: function () {
        return new MenuButton(EditorTypes_1.MarkType.Style, react_1.default.createElement(icons_1.Styles, null));
    },
    comment: function () {
        return new CommentButton();
    },
};
var configureToolbarButtons = function (buttons) {
    return buttons.map(function (button) {
        return exports.buttonList[button]();
    });
};
exports.configureToolbarButtons = configureToolbarButtons;
